import { HttpErrorResponse } from '@angular/common/http';
import { Deserializable } from '../deserializable';
import { ArbFacilitator } from '../general/arb-facilitator';
import { Broker } from '../general/broker';
import { Media } from '../general/media';
import { TransactionStatus } from './transaction-status';
import { TransactionUserFiaPins } from './transaction-user-fia-pins';
import { TransactionDeals } from '../transaction-deals/transaction-deal';
export class Transaction implements Deserializable {
  /* 
    PreliminaryProfit = Total profit/loss from Dooya email eg "TOTAL PROFIT/LOSS: 2,342.48 (1.44 %)"
    TradeProfit = ClearedTradeAmount - TradeAmount eg. Total Amount Owed from DOOYA: 165,241.70 - Total ZAR Sent: 163,500.00 (minus R500) = R2241.70
    TotalProfit = TradeProfit - BrokerBillingPercentage eg. R2241.70-10% = R2017.53
    */

  id: number;
  arbFacilitatorId: number;
  arbFacilitator: ArbFacilitator;
  brokerId: number;
  broker: Broker;
  userId: number;
  amountSent: number;
  amountSentCurrencyId: number;
  amountReceived: number;
  amountReceivedCurrencyId: number;
  forexRate: number;
  forexRateCurrencyId: number;
  preliminaryProfit: number;
  preliminaryProfitCurrencyId: number;
  preliminaryProfitPercentage: number;
  arbFacilitatorFeePercentage: number;
  arbFacilitatorFee: number;
  arbFacilitatorFeeCurrencyId: number;
  unspentTradeFunds: number;
  unspentTradeFundsCurrencyId: number;
  withdrawlFee: number;
  withdrawlFeeCurrencyId: number;
  totalProfit: number;
  totalProfitPercentage: number;
  transactionStartDate: string;
  transactionEndDate: string;
  totalProfitCurrencyId: number;
  clearedTradeAmount: number;
  clearedTradeAmountCurrencyId: number;
  bankFees: number;
  bankFeesCurrencyId: number;
  tradeAmount: number;
  tradeAmountCurrencyId: number;
  tradeProfit: number;
  tradeProfitCurrencyId: number;

  fiaAmount: number;
  sdaAmount: number;
  fiaDollarAmount: number;
  sdaDollarAmount: number;
  transactionStatus: TransactionStatus = new TransactionStatus();
  transactionStatusId: number;
  originalTransactionStatusId: number;
  transactionUserFiaPins: TransactionUserFiaPins[] = [];
  fullName: string;
  supportingMedia: Media[] = [];
  selected: boolean = false;
  busy: boolean = false;
  reprocessTrade: boolean = false;

  isUpdating: boolean = false;
  recentlyUpdated: boolean = false;
  updateSuccess: boolean = false;
  isCritical: boolean = false;
  error: HttpErrorResponse;
  dealRateChangedText: string = '';

  transactionDeals: TransactionDeals[] = [];

  get bookNowReceived(): string | undefined {
    return this.transactionDeals[0]?.bookNowReceived;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
